import { subcourseConstants } from "../constants/subcourseConstants"
import { courseConstants } from "../constants/courses"
const initialState = {
  fetchingSubcourse: false
}

export function subcourses(state = initialState, action) {
  switch (action.type) {
    case subcourseConstants.GET_SUBCOURSE_REQUEST:
      return {
        ...state,
        fetchingSubcourse: true
      }

    case subcourseConstants.GET_SUBCOURSE_SUCCESS:
      return {
        ...state,
        fetchingSubcourse: false,
        subcourse: action.subcourse
      }

    case subcourseConstants.GET_SUBCOURSE_FAILURE:
      return {
        ...state,
        fetchingSubcourse: false
      }
    case courseConstants.TOGGLE_SUBCOURSE_STATUS_REQUEST:
      return {
        ...state,
        togglePublishStatus: true
      }
    case courseConstants.TOGGLE_SUBCOURSE_STATUS_SUCCESS:
      state.subcourse.published = action.subcourse.status
      return {
        ...state,
        togglePublishStatus: false
      }
    case courseConstants.TOGGLE_SUBCOURSE_STATUS_FAILURE:
      return {
        ...state,
        togglePublishStatus: false,
        error: action.error
      }

    case subcourseConstants.UPDATE_SUBCOURSE_NAME_REQUEST:
      return {
        ...state,
        updatingName: true
      }
    case subcourseConstants.UPDATE_SUBCOURSE_NAME_SUCCESS:
      return {
        ...state,
        updatingName: false,
        subcourse: {
          ...state.subcourse,
          displayName: action.subcourse.displayName
        }
      }
    case subcourseConstants.UPDATE_SUBCOURSE_NAME_FAILURE:
      return {
        ...state,
        updatingName: false
      }

    case subcourseConstants.UPDATE_SUBCOURSE_CODE_REQUEST:
      return {
        ...state,
        updatingCode: true
      }
    case subcourseConstants.UPDATE_SUBCOURSE_CODE_SUCCESS:
      return {
        ...state,
        updatingCode: false,
        subcourse: {
          ...state.subcourse,
          name: action.subcourse.name
        }
      }
    case subcourseConstants.UPDATE_SUBCOURSE_CODE_FAILURE:
      return {
        ...state,
        updatingCode: false
      }

    case subcourseConstants.MOVE_SUBCOURSE_REQUEST:
      return {
        ...state,
        movingSubcourse: true
      }
    case subcourseConstants.MOVE_SUBCOURSE_SUCCESS:
      return {
        ...state,
        movingSubcourse: false,
        subcourse: {
          ...state.subcourse,
          courseId: action.course.id,
          course: action.course
        }
      }
    case subcourseConstants.MOVE_SUBCOURSE_FAILURE:
      return {
        ...state,
        movingSubcourse: false,
        moveError: action.error
      }
    case courseConstants.SET_NODE_SUCCESS:
      return {
        ...state,
        subcourse: {
          ...state.subcourse,
          node: action.nodeId
        }
      }
    case courseConstants.CREATE_SECTION_SUCCESS:
      state.subcourse &&
        (state.subcourse.sections = action.section.subcourse.sections)
      return {
        ...state
      }

    default:
      return state
  }
}
